module.exports = __webpack_public_path__ + "img/LTS_PWC.6e7ad3e6.gif";